export const REVIEW_COUNT = 124;
export const REVIEW_RATING = "5.0";
